<template>
    <div>
        <div>
            <el-card shadow="never" class="aui-card--fill">
            <el-form label-position="top" label-width="145px" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" >
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="spring bean名称" prop="beanName">
                            <el-input v-model="dataForm.beanName" placeholder="spring bean名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="参数" prop="params">
                            <el-input v-model="dataForm.params" placeholder="参数"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="cron表达式" prop="cronExpression">
                            <el-input v-model="dataForm.cronExpression" placeholder="cron表达式"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="任务状态  0：正常  1：暂停" prop="status">
                            <el-input v-model="dataForm.status" placeholder="任务状态  0：正常  1：暂停"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

        </el-card>
        </div>
        <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16">
                    <div class="grid-content" />
                </el-col>
                <el-button @click="cancel" >{{ $t('cancel') }}</el-button>
                <el-button type="primary" @click="scheduleJobUpdate">{{ $t('confirm') }}</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        jobId: '',
        beanName: '',
        params: '',
        cronExpression: '',
        status: '',
        remark: '',
        createDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        beanName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cronExpression: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.$request.get(
        `/task/schedulejob/find/`+this.$route.query.jobId
    ).then((res, total, code, data) => {
      this.dataForm = data.data
    }).catch(() => { })
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.jobId) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/task/schedulejob/${this.dataForm.jobId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    scheduleJobUpdate: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.put(
          `/task/schedulejob/update`,
          this.dataForm
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          this.tabRemove()
        }).catch(() => { })

      })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 取消按钮
    cancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          this.tabRemove()
      }).catch(() => {
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
          return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
  }
}
</script>
<style lang='scss' scoped>
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
</style>
